// Get next jobs list for a user  ***********************
// pathname: /v1/user/next-jobs
// **********************************************************
import { useSwrApi } from '@hooks/useSwrApi';

interface UseSwrNextJobsProps {
  locale?: Locale;
  shouldFetch?: boolean;
  serverData?: ApiSchema<'NextJobData'>[];
}

/**
 * @description SWR Get next jobs list for a user (merged from saved searches, job applications).
 * @param props
 */
export const useSwrNextJobs = (props: UseSwrNextJobsProps) => {
  const { locale = 'ro', shouldFetch = true, serverData } = props;

  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiSchema<'NextJobData'>[]>({
    url: '/v1/user/next-jobs',
    locale,
    shouldFetch,
    serverSideData: serverData,
    apiOptions: {
      dedupingInterval: 60 * 1000, // 1 minute
    },
  });

  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
